/**
 * Layout: Hero - Video
 * Slug: hero_video
 */

function toggleMute(video, controls) {
	video.muted = !video.muted;
	controls.classList.toggle("muted", video.muted);
	controls.classList.toggle("unmuted", !video.muted);
}
function togglePlayback(video, controls) {
	video.paused ? video.play() : video.pause();
	controls.classList.toggle("paused", video.paused);
	controls.classList.toggle("playing", !video.paused);
}

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.hero_video-layout, .flex-layout.hero_content_video-layout');

	layouts.forEach((layout) => {
		const video = layout.querySelector(".bg-video");
		if(video) {
		const videoControls = layout.querySelector(".video-controls");
			// const volumeControl = videoControls.querySelector(".volume");
			const playbackControl = videoControls.querySelector(".play-pause");
			// volumeControl.addEventListener("click", () => toggleMute(video, videoControls));
			playbackControl.addEventListener("click", () => togglePlayback(video, videoControls));
		}
	});
});
